import KpiCard from '../common/KpiCard';
import useMetric from '../../hooks/useMetric';
import { formatNumber, formatPercent } from '../../utils/format';

export default function EscalationRateCard() {
  const { status, data, error, retry } = useMetric('escalationRate');
  const delta = data ? Math.round((data.value - data.previous) * 10) / 10 : null;
  return (
    <KpiCard
      testId="kpi-escalation-rate" title="Escalation Rate" icon="bi-person-raised-hand" tone="danger" to="/conversations"
      status={status} error={error} onRetry={retry} emptyText="No conversations to measure escalation."
      value={data && formatPercent(data.value)} delta={delta} lowerIsBetter
      sparkline={data?.sparkline}
      footnote={data && `${formatNumber(data.escalated)} of ${formatNumber(data.total)} handed to humans`}
    />
  );
}
